import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import "./TokenForm.css";

function TokenForm({ authToken, onTokenCreated }) {
  const [truckNumber, setTruckNumber] = useState("");
  const [qrData, setQrData] = useState(null);
  const [tokenTime, setTokenTime] = useState(null);
  const [vehicleNumber, setVehicleNumber] = useState(null);
  const isSubmittingRef = useRef(false); // Immediate flag
  const qrRef = useRef(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!truckNumber || isSubmittingRef.current) return;

    isSubmittingRef.current = true;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/tokens`,
        { truckNumber },
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      const { transactionId, createdAt } = response.data;
      setQrData(transactionId);
      setTokenTime(createdAt);
      setVehicleNumber(truckNumber);
      setTruckNumber("");
      if (onTokenCreated) onTokenCreated();
    } catch (err) {
      alert("Failed to create token");
    } finally {
      isSubmittingRef.current = false;
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); // prevent native form submit
        handleSubmit(event);
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [truckNumber]);

  useEffect(() => {
    if (qrData && qrRef.current) {
      setTimeout(() => {
        const canvas = qrRef.current.querySelector("canvas");
        if (!canvas) return;

        const qrImage = canvas.toDataURL("image/png");
        const printWindow = window.open("", "PRINT", "height=400,width=360");
        printWindow.document.write(
          `<html><head><title>Print QR Code</title></head>
          <style>
              body {
                width: 78mm;
                margin: 0 auto;
                padding: 0;
                font-family: monospace;
                text-align: center;
                font-size: 13px;
              }
              h2, h3, p {
                margin: 4px 0;
              }
              img {
                display: block;
                margin: 8px auto;
                max-width: 40%;
              }
              @media print {
                body {
                  margin: 0;
                }
              }
            </style>
          <body>`
        );
        printWindow.document.write(`<h2>Courtyard Pavilion Pvt Ltd</h2>`);
        printWindow.document.write(`<h3>ID: ${qrData}</h3>`);
        printWindow.document.write(
          `<p>Vehicle Number: <b>${vehicleNumber}</b></p>`
        );
        printWindow.document.write(`<img src="${qrImage}" alt="QR Code"/>`);
        printWindow.document.write(
          `<p>Time: <b>${new Date(tokenTime).toLocaleString()}</b></p>`
        );
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => printWindow.print(), 500);
      }, 300);
    }
  }, [qrData]);

  return (
    <div className="token-form-container">
      <form onSubmit={handleSubmit}>
        <input
          value={truckNumber}
          onChange={(e) => setTruckNumber(e.target.value)}
          placeholder="Truck Number"
          className="border p-2 mr-2"
        />
        <button type="submit" className="bg-blue-500 text-white px-4 py-2">
          Create Token
        </button>
      </form>
      <div style={{ display: "none" }} ref={qrRef}>
        {qrData && <QRCodeCanvas value={qrData} size={256} />}
      </div>
    </div>
  );
}

export default TokenForm;
